import { gql } from '@apollo/client';

const schema = {
  create: {
    name: 'addUser',
    serviceName: 'unitadmin',
    query: gql`
      mutation addUser(
        $gender: Int
        $lastname: String
        $firstname: String
        $cellphone: String!
        $user_category_id: String
      ) {
        addUser(
          gender: $gender
          lastname: $lastname
          firstname: $firstname
          cellphone: $cellphone
          user_category_id: $user_category_id
        ) {
          messages
        }
      }
    `,
  },
};

export default schema;
